import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// Import Types
import type { DropdownOption } from 'types';
// Import UI components
import { Dropdown } from '@geneui/components';

interface TDropdownProps extends React.ComponentProps<typeof Dropdown> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: DropdownOption<any>[];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

const TDropdown: React.FC<TDropdownProps> = ({ data = [], ...rest }) => {
    const { t } = useTranslation();
    const [_data, _setData] = useState(data);

    useEffect(() => {
        _setData(
            data.map((item) => {
                item.label = t(item.label);
                return item;
            }),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return <Dropdown data={_data} {...rest} />;
};

export default memo(TDropdown);
